module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/MODAL-confirmModal/confirmModal.component.css
// module id = ./src/app/components/MODAL-confirmModal/confirmModal.component.css
// module chunks = main